import { Code, Gift, Smile, Trophy, Zap } from 'lucide-react';

import { Badge, cn } from '@codes/ui-kit';

export const getWorkspaceBadge = (stereo?: string, showIcon = true, className?: string) => {
    switch (stereo) {
        case 'free':
        case 'basic':
            return (
                <Badge
                    variant="C"
                    className={cn(
                        'gap-[6px] border-transparent text-[#3A5A4E] [background:linear-gradient(#E9FFE3,#E9FFE3)_padding-box,linear-gradient(90deg,#08BC80,#5DD779,#92E77B)_border-box] dark:text-[#D7F9E5] dark:[background:linear-gradient(#1A2C26,#1A2C26)_padding-box,linear-gradient(90deg,#08BC80,#5DD779,#92E77B)_border-box]',
                        className
                    )}
                >
                    {showIcon ? <Gift size={18} /> : null}
                    Basic
                </Badge>
            );
        case 'pro':
            return (
                <Badge
                    variant="C"
                    className={cn(
                        'gap-[6px] border border-transparent text-[#FF7300] [background:linear-gradient(#FFE7D8,#FFE7D8)_padding-box,linear-gradient(90deg,#FF6200,#FFA45A,#FFD45F)_border-box] dark:text-[#fdba74] dark:[background:linear-gradient(#4a2103,#4a2103)_padding-box,linear-gradient(90deg,#FF6300,#FFA45A,#FFD45F)_border-box]',
                        className
                    )}
                >
                    {showIcon ? <Zap size={18} /> : null}
                    Pro
                </Badge>
            );
        case 'ent':
            return (
                <Badge
                    variant="C"
                    className={cn(
                        'gap-[6px] border border-transparent text-[#07388A] [background:linear-gradient(#E6EFFE,#E6EFFE)_padding-box,linear-gradient(90deg,#2E78F3,#2ED5F3,#7BDDF8)_border-box] dark:text-[#a5b4fc] dark:[background:linear-gradient(#1c274b,#1c274b)_padding-box,linear-gradient(90deg,#2E78F3,#2ED5F3,#7BDDF8)_border-box]',
                        className
                    )}
                >
                    {showIcon ? <Trophy size={18} /> : null}
                    adv
                </Badge>
            );
        default:
            return null;
    }
};

export const getProjectBadge = (stereo?: string, showIcon = true, className?: string) => {
    switch (stereo) {
        case 'dev':
            return (
                <Badge
                    variant="C"
                    className={cn(
                        'border-gray-200 bg-white text-gray-black gap-[6px] dark:border-gray-800 dark:bg-gray-900 dark:text-gray-50',
                        className
                    )}
                >
                    {showIcon ? <Code size={18} /> : null}
                    Dev
                </Badge>
            );
        case 'prod':
            return (
                <Badge
                    variant="C"
                    className={cn(
                        'border-gray-200 bg-white text-gray-black gap-[6px] dark:border-gray-800 dark:bg-gray-900 dark:text-gray-50',
                        className
                    )}
                >
                    {showIcon ? <Smile size={18} /> : null}
                    Ops
                </Badge>
            );
        default:
            return null;
    }
};
